import { action } from 'satcheljs';

export interface FeedbackRibbonClickProps {
    SessionId: string;
    Feature: string;
    RibbonResponse: string;
    SubFeature?: string;
    Metadata?: string;
}

export const logFeedbackRibbonClickResponse = action(
    'logFeedbackRibbonClickResponse',
    (feedbackRibbonClickResponse: FeedbackRibbonClickProps) => feedbackRibbonClickResponse
);
